import React from "react";
import {
	View,
	StyleSheet
} from "react-native";

import SimpleMarkdown from "simple-markdown";
import Rules from "./rules.js";
import merge from "deepmerge";
import xtend from "xtend";

import Style from "ae-style";

var styles = StyleSheet.create({
	paragraph: {
		flexDirection: "row",
		flexWrap: "wrap",
		alignItems: "flex-start",
		justifyContent: "flex-start",
		marginBottom: Style.layout.marginMedium
	},
	inlineCode: {
		backgroundColor: Style.colors.lightGrey,
		fontFamily: "Courier",
		fontWeight: "bold"
	},
	listItem: {
		flexDirection: "row"
	},
	listItemContent: {
		flexDirection: "row",
		flexWrap: "wrap",
		maxWidth: "95%",
		marginBottom: Style.layout.marginSlim
	},
	listContainer: {
		marginBottom: 20,
		maxWidth: "95%"
	},
});

var unimplementedRules = [
	"mailto",
	"table",
	"url",
	"autolink",
	"blockQuote",
	"codeBlock"
];

export default class Markdown extends React.PureComponent {
	constructor(props){
		super(props);

		this.state = {
			width: 0
		};
		this.onLayout = onLayout.bind(this);
	}
	render(){
		var props = this.props;
		var rules = Rules(xtend(styles, props.style), {
			noPdfFullScreen: props.noPdfFullScreen,
			contrast: props.contrast,
			width: this.state.width
		});
		var useRules = removeRules(merge(SimpleMarkdown.defaultRules, rules));
		var parser = SimpleMarkdown.parserFor(useRules);

		var parse = function(source){
			var blockSource = source + "\n\n";
			return parser(blockSource, {
				inline: false
			});
		};
		var renderer = SimpleMarkdown.reactFor(SimpleMarkdown.ruleOutput(useRules, "react"));

		var child = Array.isArray(props.children) ? props.children.join(" ") : props.children;
		var parsed = parse(child);
		return (
			<View onLayout={this.onLayout}>
				{renderer(parsed)}
			</View>
		);
	}
}

function removeRules(rules){
	return Object.keys(rules).reduce(function(acc, rule){
		if(unimplementedRules.indexOf(rule) === -1)
			acc[rule] = rules[rule];
		return acc;
	}, {});
}

function onLayout({nativeEvent}){
	const {width} = (nativeEvent || {}).layout;
	this.setState({width});
}